import { useState } from 'react'

import { Popconfirm } from 'antd'
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons'
import { useSelector } from 'react-redux'

import IconButton from './IconButton'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { validateString } from '../../../utils'

/**
 * An action something already known makes dangerous : the button wears the warning colour, turns its
 * icon into a warning under the cursor, and asks before doing it. Given no confirmation to ask, it is
 * a plain IconButton.
 */
const ConfirmableIconButton = ({ className = '', confirmation = null, disabled, icon, text, type, onClick }) => {
  const t = useSelector(selectTranslate)

  const [hovered, setHovered] = useState(false)

  const confirms = validateString(confirmation, { notEmpty: true }).valid

  /**
   * rc-trigger fires the child's own onClick besides opening the popup : a button left with a handler
   * would run the action before the confirmation it is wrapped in has even been answered.
   */
  const button = (
    <IconButton
      className={confirms ? `${className} ant-warning-button` : className}
      disabled={disabled}
      icon={confirms && hovered ? faExclamationTriangle : icon}
      text={text}
      type={type}
      onClick={confirms ? undefined : onClick}
      onMouseEnter={confirms ? () => setHovered(true) : undefined}
      onMouseLeave={confirms ? () => setHovered(false) : undefined}
    />
  )

  if (!confirms) {
    return button
  }

  return (
    <Popconfirm
      cancelText={t('common.cancel')}
      okText={t('common.yes')}
      placement='top'
      title={confirmation}
      onConfirm={onClick}
    >
      {button}
    </Popconfirm>
  )
}

export default ConfirmableIconButton
